interface INameExtention extends Window {
	modalPlayer: any;
	heroPlayer: any;
}

declare let window: INameExtention;
import Player from "@vimeo/player";

let timerId;

const HeroVideo = {
	el: {
		heroVideo: document.querySelector<HTMLElement>(".hero__video-container"),
		modal: document.querySelector<HTMLElement>(".hero-video-modal"),
	},

	init() {
		if (this.el.heroVideo && this.el.modal) {
			const heroVideo = this.el.heroVideo;
			const videoOverlay = heroVideo.querySelector<HTMLElement>(
				".hero__video-overlay",
			);
			const video = heroVideo.querySelector<HTMLVideoElement>(".hero__video");

			// elements for video modal
			const modal = this.el.modal;
			const modalVideo = modal.querySelector<HTMLIFrameElement>(
				".hero-video-modal__video",
			);
			const modalClose = modal.querySelector<HTMLElement>(
				".hero-video-modal__close",
			);

			//set video modal src to video src
			modalVideo.setAttribute("src", video.dataset.url);

			const heroPlayer = new Player(
				document.querySelector<HTMLElement>("#hero-player"),
			);
			const modalPlayer = new Player(
				document.querySelector<HTMLElement>("#modal-player"),
			);

			// Expose player so it can be used from the console
			window.heroPlayer = heroPlayer;
			window.modalPlayer = modalPlayer;

			window.heroPlayer.getColors().then(function (colors) {
				modalClose.style.backgroundColor = `#${colors[0]}`;
				modalClose.style.color = `#${colors[1]}`;
			});

			if (videoOverlay != null && modal != null) {
				// listening to clicks on document to toggle modal and buttons
				document.addEventListener("click", (event) => {
					const toggleModal =
						event.composedPath().includes(modalClose) ||
						event.composedPath().includes(videoOverlay);

					// toggle modal
					if (toggleModal) {
						this.toggleVideoModal(modal);
					}
				});

				document.addEventListener("keyup", (event) => {
					if (event.key === "Enter" || event.key === " ") {
						const toggleModal =
							event.composedPath().includes(modalClose) ||
							event.composedPath().includes(videoOverlay);

						if (toggleModal) {
							event.preventDefault();
							this.toggleVideoModal(modal);
						}
					}
				});

				// start and stop trailer on mouseover and mouseout
				document.addEventListener("mouseover", (event) => {
					const playVideoTrailer = event.composedPath().includes(videoOverlay);

					if (playVideoTrailer) {
						this.playVideoTrailer();
					}
				});

				document.addEventListener("mouseout", (event) => {
					const stopVideoTrailer = event.composedPath().includes(videoOverlay);

					if (stopVideoTrailer) {
						this.stopVideoTrailer();
					}
				});

				// to enable keyboard controls
				window.modalPlayer.on("play", () => {
					window.focus();
				});

				// when video ends unload it so it starts again
				window.modalPlayer.on("ended", () => {
					window.modalPlayer.unload();
				});
			}
		}
	},

	playVideoTrailer() {
		clearTimeout(timerId);
		window.heroPlayer.play();

		timerId = setTimeout(() => {
			window.heroPlayer.pause();
		}, 5000);
	},

	playVideo() {
		if (window.heroPlayer) {
			window.heroPlayer.play().catch((error: any) => {
				console.error("Error playing video:", error);
			});
		}
	},

	stopVideoTrailer() {
		clearTimeout(timerId);
		window.heroPlayer.unload();
	},

	toggleVideoModal(videoModal) {
		const isOpen = videoModal.classList.contains("open");
		const iframe = videoModal.querySelector("iframe") as HTMLIFrameElement;

		if (isOpen) {
			document.body.classList.remove("h-disable-scroll");
			videoModal.classList.remove("open");
			window.modalPlayer.unload();
			if (iframe) {
				iframe.blur();
			}
		} else {
			document.body.classList.add("h-disable-scroll");
			videoModal.classList.add("open");
			if (iframe) {
				iframe.focus();
			}
		}
	},
};

export default HeroVideo;
